export class DropdownOption<TValue> {
    label: string;
    value?: TValue;
    subValues?: DropdownSubOption<TValue>[];

    constructor(label: string, value?: TValue, subValues?: DropdownSubOption<TValue>[]) {
        this.label = label;
        this.value = value;
        this.subValues = subValues;
    }
}

export class DropdownSubOption<TValue> {
    label: string;
    value: TValue;

    constructor(label: string, value: TValue) {
        this.label = label;
        this.value = value;
    }
}
